import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/youtube-to-shorts")({
  beforeLoad: () => {
    throw redirect({ to: "/tools/youtube-to-shorts", statusCode: 301 })
  },
})
